import React from 'react';
import User from "../models/User"
import CallAccessExtensionAndQueues from './CallAccessExtensionAndQueues';


type Props = {
    userId?: string
    model?: User
    onUpdate?: (user: User) => void
}




export default function CallsAccess(props: Props) {

    return (
        <>
            <CallAccessExtensionAndQueues userId={props.userId} model={props.model} onUpdate={props.onUpdate} />
        </>
    )
}


